import {Icon} from '@wandb/components';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import React from 'react';
// eslint-disable-next-line wandb/no-deprecated-imports
import {
  Button as AriaButton,
  type ButtonProps as AriaButtonProps,
} from 'react-aria-components';

export const WBAgentChatButton = ({
  isLoading,
  ...props
}: AriaButtonProps & {
  isLoading?: boolean;
}) => {
  return (
    <Tailwind>
      <AriaButton
        aria-label={isLoading ? 'Workspace agent (loading)' : 'Workspace agent'}
        {...props}
        className="group rounded-full p-4 mr-8">
        <div className="flex h-32 w-32 rounded-full items-center justify-center bg-teal-550 text-white outline outline-2 outline-transparent group-hover:outline-[#CDF4F7] group-focus-visible:outline-[#CDF4F7]">
          <span
            className={
              isLoading
                ? 'inline-flex animate-spin [animation-duration:4s]'
                : 'inline-flex'
            }>
            <Icon icon={isLoading ? 'loading' : 'lightboard-solid'} size="md" />
          </span>
        </div>
      </AriaButton>
    </Tailwind>
  );
};
